import {
  PRICING_REQUEST,
  PRICING_SUCCESS,
  PRICING_FAIL,
} from '../constants/pricingConstants';

const initialState = {
  loading: false,
  pricing: {
    bookCreationWithCopyPrice: 160,
    additionalCopyPrice: 80,
    languageAddonPrice: 0,
    shippingPhysicalPrice: 60,
  },
  error: null,
};

export const pricingReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRICING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PRICING_SUCCESS:
      return {
        ...state,
        loading: false,
        pricing: action.payload,
        error: null,
      };
    case PRICING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
